import Logo from "../Logo/Logo";
import styles from "./ConfigError.module.css";

/**
 * Shown instead of the application when a production build has no Firebase
 * configuration (Implementation Guide §15).
 *
 * This is a deployment error, not a user error, so it is deliberately
 * blunt. It lists variable *names* only; no values are ever rendered.
 */
const ConfigError = ({ missing = [] }) => (
  <div className={styles.ConfigError}>
    <div className={styles.card} role="alert">
      <Logo size="md" className="mb-3" />

      <h1 className="h5 mb-2">This build isn&rsquo;t configured yet.</h1>
      <p className={styles.body}>
        I Don&rsquo;t Know Football can&rsquo;t reach its database, so signing
        in and saving progress are unavailable. Nothing is wrong with your
        device. This needs a fix from whoever deployed the site.
      </p>

      <details className={styles.details}>
        <summary>Deployment detail</summary>
        <p className="mb-1">
          The following environment variables were empty at build time:
        </p>
        <ul>
          {missing.map((key) => (
            <li key={key}>
              <code>{key}</code>
            </li>
          ))}
        </ul>
        <p className="mb-0">
          Set them in the deployment environment and rebuild. Create React App
          inlines <code>REACT_APP_*</code> values at build time, so a rebuild is
          required: restarting the host is not enough.
        </p>
      </details>
    </div>
  </div>
);

export default ConfigError;
